import { WidgetShop, WidgetVerification, WidgetVerificationAddress } from "@/types/frontend";
import axios, { AxiosInstance } from "axios";
import config from "@/frontend/one-id-widget/config";

const apiInstance: AxiosInstance = axios.create({
    baseURL: config.api.url,
    timeout: config.api.timeout,
});

class Api {
    async getShop(params: object): Promise<WidgetShop> {
        const res = await apiInstance.get("/get-shop", {
            params: {
                shop_domain: config.shopDomain,
                ...params,
            },
        });
        return res.data.data;
    }

    async getVerification(params: object): Promise<WidgetVerification> {
        const res = await apiInstance.get("/verification", {
            params: {
                shop_domain: config.shopDomain,
                ...params,
            },
        });
        return res.data.data;
    }

    async getVerificationUserAddress(verification: WidgetVerification): Promise<WidgetVerificationAddress | null> {
        const res = await apiInstance.get("/verification/user-address", {
            params: {
                shop_domain: config.shopDomain,
                id: verification.id,
                address_key: verification.address_key,
            },
        });
        return res.data.data;
    }

    async removeVerificationUserAddress(params: object): Promise<WidgetVerification> {
        const res = await apiInstance.post("/verification/user-address-remove", {
            shop_domain: config.shopDomain,
            ...params,
        });
        return res.data.data;
    }

    async updateVerification(params: object): Promise<WidgetVerification> {
        const res = await apiInstance.post("/verification", {
            shop_domain: config.shopDomain,
            ...params,
        });
        return res.data.data;
    }
}

export const api = new Api();
